import { render, staticRenderFns } from "./ShippingListItem.vue?vue&type=template&id=70b88624"
import script from "./ShippingListItem.vue?vue&type=script&lang=js"
export * from "./ShippingListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports